module.exports = __webpack_public_path__ + "img/tobbySquare3.76414831.jpg";